// Marketing-cookie consent, stored per visitor. Host-scoped like the cart/prefill
// keys so two dev stores on one origin can't inherit each other's choice.
//
// This is the ONLY thing standing between a visitor and the seller's ad pixels,
// so the default is deliberately "unknown" (= hold), never "granted".

const KEY = `dk:consent:${location.host}`

export type ConsentState = "unknown" | "granted" | "denied"

export function readConsent(): ConsentState {
  try {
    const v = localStorage.getItem(KEY)
    return v === "granted" || v === "denied" ? v : "unknown"
  } catch {
    // Private mode with storage blocked: treat as undecided rather than granted.
    return "unknown"
  }
}

export function writeConsent(v: Exclude<ConsentState, "unknown">): void {
  try {
    localStorage.setItem(KEY, v)
  } catch {
    /* a visitor who blocks storage simply gets asked again next visit */
  }
}
